const axios = require( 'axios' );

class VoiceService {
	service;
	voiceId;
	config;

	static voiceOptions() {
		return [];
	}

	constructor( service ) {
		this.service = service;
		this.scanEnv();

		// Allows default to be set by .env
		if ( 'VOICE_ID' in this.config ) {
			this.setVoice( this.config.VOICE_ID );
		}
	}

	/**
	 * 
	 * @param {String} key 
	 * @returns 
	 */
	scanEnv() {
		let keyprefix = 'VOICE_' + this.service.toUpperCase() + '_';
		const config = {};

		for ( const key in process.env ) {
			if ( key.startsWith( keyprefix ) ) {
				config[ key.substring(keyprefix.length) ] = process.env[key];
			}
		}

		this.config = config;
	}

	/**
	 * 
	 * @param {String} voice_id 
	 */
	setVoice( voice_id ) {
		this.voiceId = voice_id;
	}

	/**
	 * 
	 * @param {String} text 
	 * @param {Boolean} withTimestamps 
	 */
	async synthesizeSpeech( text, withTimestamps ) {
		throw 'Extend this method for the service';
	}

	/**
	 * 
	 * @param {Object} param
	 * @returns {Blob} MpegData
	 */
	async apiRequest( { url, data, headers } ) {

		const response = await fetch( url, {
			method: 'POST',
			headers,
			body: JSON.stringify( data )
		});

		if ( !response.ok ) {
			const errorText = await response.text();
			console.error( 'API Error:', response.status, response.statusText, errorText );
			throw new Error(`API request failed: ${response.status} ${response.statusText}`);
		}

		return await response.json();
	}

}

module.exports = VoiceService;
